import React, { useState } from 'react';
import { Brain, User, X, ArrowsOut, ArrowsIn } from '@phosphor-icons/react';
import { motion, AnimatePresence } from 'framer-motion';

const FloatingPortals = () => {
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  const portals = [
    {
      id: 'echo-buble',
      name: 'Echo Buble',
      url: 'https://chatgpt.com/g/g-67f1fb3ae5e88191879c26232f5ec78f-echo-buble',
      icon: Brain
    },
    {
      id: 'xavier-lennox',
      name: 'Xavier Lennox',
      url: 'https://chatgpt.com/g/g-6884d78f0f588191bc57ad574d807ee3-xavier-lennox',
      icon: User
    }
  ];

  return (
    <>
      {/* Toggle Button (Always Visible) */}
      {!isPanelOpen && (
        <button
          onClick={() => setIsPanelOpen(true)}
          className="fixed bottom-8 right-8 w-14 h-14 rounded-full bg-[#00F0FF] flex items-center justify-center shadow-lg hover:bg-[#00D9E8] transition-colors z-50 breathing-glow"
          data-testid="open-portals-btn"
          title="Open Old Mind Portals"
        >
          <Brain size={28} weight="duotone" className="text-[#030305]" />
        </button>
      )}

      {/* Floating Panel */}
      <AnimatePresence>
        {isPanelOpen && (
          <motion.div
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 200 }}
            className="fixed bottom-0 left-0 right-0 h-[50vh] bg-[#0B0E14] border-t border-white/10 shadow-2xl z-[60]"
            data-testid="portals-panel"
          >
            {/* Header Bar */}
            <div className="flex items-center justify-between p-4 border-b border-white/10 bg-black/30">
              <div>
                <h3 className="text-lg font-bold neon-cyan">Old Mind Portals</h3>
                <p className="text-xs text-gray-500">Legacy ChatGPT Interfaces</p>
              </div>
              <button
                onClick={() => setIsPanelOpen(false)}
                className="w-10 h-10 rounded-full bg-[#FF6B6B] flex items-center justify-center hover:bg-[#FF5555] transition-colors"
                data-testid="close-portals-btn"
              >
                <X size={20} weight="bold" className="text-white" />
              </button>
            </div>

            {/* Side-by-Side Iframes */}
            <div className="flex h-[calc(100%-60px)]">
              {/* Left Half - Echo Buble */}
              <div className="w-1/2 border-r border-white/10 relative">
                <div className="absolute top-2 left-2 z-10 px-3 py-1 bg-black/80 rounded text-xs font-bold text-[#00F0FF] mono">
                  Echo Buble
                </div>
                <iframe
                  src={portals[0].url}
                  className="w-full h-full border-none"
                  title="Echo Buble"
                  data-testid="iframe-echo-buble"
                />
              </div>

              {/* Right Half - Xavier Lennox */}
              <div className="w-1/2 relative">
                <div className="absolute top-2 left-2 z-10 px-3 py-1 bg-black/80 rounded text-xs font-bold text-[#FFB800] mono">
                  Xavier Lennox
                </div>
                <iframe
                  src={portals[1].url}
                  className="w-full h-full border-none"
                  title="Xavier Lennox"
                  data-testid="iframe-xavier-lennox"
                />
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default FloatingPortals;